<template>
  <IngredientCardPopover>
    <template #items>
      <IngredientCardPopoverItem
        v-if="page !== 'vegan'"
        :title="card.sections[0].title"
        :items="card.sections[0].items"
      />
      <IngredientCardPopoverItem
        :title="card.sections[1].title"
        :items="card.sections[1].items"
      />
    </template>
    <img
      src="https://cdn.shopify.com/s/files/1/1209/5722/files/card-protein.webp"
      alt="Protein"
      width="140"
      class="object-cover"
    >
  </IngredientCardPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IngredientCardPopover from './ingredient-card-popover.vue'
import IngredientCardPopoverItem from './ingredient-card-popover-item.vue'
import { ingredientCards, type Page } from '@/utils/ingredient-cards'

export interface Props {
  page: Page
}

defineProps<Props>()

const card = computed(() => ingredientCards.find(c => c.id === 1)!)
</script>
